import React, { memo, forwardRef } from 'react';
import { Box, BoxProps } from '@mui/material';
import { makeStyles } from '@mui/styles';

import StyledSubmitButton from '../Shared/StyledSubmitButton';

const useStyles = makeStyles(() => ({
  buttonText: {
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    textTransform: 'uppercase',
  },
  topRightStars: {
    position: 'absolute',
    top: -20,
    right: -20,
  },
  bottomLeftStars: {
    position: 'absolute',
    bottom: -17,
    left: -24,
  },
}));

export interface ICodeSubmitButtonProps {
  isDisabled?: boolean;
  wrapperProps?: BoxProps;
}

const CodeSubmitButton = forwardRef(({ isDisabled = false, wrapperProps = {} }: ICodeSubmitButtonProps, ref) => {
  const classes = useStyles();

  return (
    <Box ref={ref} mt={6} display="flex" justifyContent="center" alignItems="center" {...wrapperProps}>
      <Box position="relative" width="100%" mx={6} my={0}>
        <StyledSubmitButton
          type="submit"
          id="codeStyledSubmitButton"
          data-testid="giftCodeSubmitButton"
          width="100%"
          disabled={isDisabled}
        >
          <span className={classes.buttonText}>Continue</span>
        </StyledSubmitButton>
      </Box>
    </Box>
  );
});

export default memo(CodeSubmitButton);
